import styled from "styled-components";

const BarLabel = styled.h3.attrs({ className: "text-uppercase" })`
  align-self: center;
  margin: 0;
  text-align: right;
`;

export default BarLabel;
